export const typesOptions = [
  { id: "", name: "Tipo de busca" },
  { id: "name", name: "Nome" },
  { id: "email", name: "Email" },
  { id: "cpf", name: "CPF" },
  { id: "id_source", name: "Id de Origem" },
  { id: "id", name: "Id do Pedido" },
];

export const itensPageOptions = [
  { id: "100", name: "100" },
  { id: "150", name: "150" },
  { id: "200", name: "200" },
];

export const initialDates = {
  dates: {
    startDate: null,
    endDate: null,
  },
};

export const ordersTypeOptions = [
  { type: false, name: "Pedido Simples" },
  { type: true, name: "Pedido Composto" },
];
